export default {
    bll: {
        getSms: (vue, params, callback) => {
            console.log(vue.apis)
            vue.$http.get('/sms/sendRegCode', {
                params
            }).then(res => {
                callback(res)
            }).catch(res => {
                callback({data: {status: 0}})
            })
        }
    }
}